import { useState, useContext } from 'react';
import DriverSettingsMasterLayout from '../../../layouts/Drivers/DriverSettingsMasterLayout';
import { Container, Row, Col } from 'react-bootstrap';
import DriverMasterLayout from "../../../layouts/Drivers/DriverMasterLayout";
import  RideDetailCard from '../../../components/Drivers/RideDetailCard/RideDetailCard';
import '../../../assets/css/Drivers/DriverActiveRides/RideCompleted.css';
import AppContext from '../../../context/AppContext';



const RideCompleted = () => {

  const { selectedRideforFindingDriver } = useContext(AppContext);

  return (
    <DriverSettingsMasterLayout screenName={"Accept Ride Details"} centered={true}>
    <DriverMasterLayout showHeader={false}>
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6} xl={5}>
          <h2 className="text-center mb-4">Ride Completed</h2>
          <RideDetailCard
            customerName={selectedRideforFindingDriver?.tdcustomer?.name}
            customerRating={selectedRideforFindingDriver?.tdcustomer?.rating || '4.8'}
            date={selectedRideforFindingDriver?.bookingDate}
            time={selectedRideforFindingDriver?.bookingTime}
            pickupLocation={selectedRideforFindingDriver?.pickuplocation}
            dropLocation={selectedRideforFindingDriver?.dropofflocation}
            totalBill={`Rs ${selectedRideforFindingDriver?.offeredFare}`}
            paymentStatus={selectedRideforFindingDriver?.paymentmethod}
          />
        </Col>
      </Row>
    </Container>
    </DriverMasterLayout>
    </DriverSettingsMasterLayout>
  );

};

export default RideCompleted;